import { api } from '../index';

const BASE_PATH = '/api/internal/planning/route_plan_expected_visits';

export type ExpectedVisit = {
  patientId: number;
  patientFullName: string;
  durationMinutes: number;
  fixedStartTime: string | null;
  timeWindowStart: string | null;
  timeWindowEnd: string | null;
  assignedCaregiverId: number | null;
  skillId: number | null;
  skillName: string | null;
};

export type ExpectedVisitScheduleBlock = { id: number; description: string };

// An expected slot the patient's schedule block leaves no room for on that date: reported so
// the planner knows why it is not offered, never loadable.
export type BlockedExpectedVisit = ExpectedVisit & { scheduleBlock: ExpectedVisitScheduleBlock };

export type ExpectedVisitsIndex = {
  expectedVisits: ExpectedVisit[];
  blockedExpectedVisits: BlockedExpectedVisit[];
};

export const routePlanExpectedVisitsApi = {
  index(date: string, career: string, groupIds?: number[]): Promise<ExpectedVisitsIndex> {
    const params: Record<string, unknown> = { date, career };
    if (groupIds && groupIds.length > 0) params['group_id_in[]'] = groupIds;

    return api({
      method: 'get',
      url: BASE_PATH,
      params,
    }).then((response) => ({
      expectedVisits: response.data.expectedVisits ?? [],
      blockedExpectedVisits: response.data.blockedExpectedVisits ?? [],
    }));
  },
};
